import { useEffect } from 'react';

/**
 * @param {Object} opts
 * @param {Object} opts.ref - instance of a DOM native element
 * @param {func} opts.onClickOutside - called with outside click
 * @param {func} opts.exceptionCb - function that returns boolean to
 *    used in for example a popover so content in popover can be clicked
 */
const useClickOutside = ({ ref, onClickOutside, exceptionCb }) => {
    const handleClickOutside = event => {
        const exception = !exceptionCb ? true : exceptionCb(event.target);
        if (ref.current && !ref.current.contains(event.target) && exception) {
            onClickOutside();
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    });
};

export default useClickOutside;
